<template>
  <div class="relative select-none">
    <BaseProgressBar
      :value="score"
      :max="descriptions.length"
      :color="description.color"
      :text="description.text"
    />

    <p class="absolute mt-1 text-sm" :class="[description.text]">
      {{ description.label }}
    </p>
  </div>
</template>

<script>
import { zxcvbn, zxcvbnOptions } from "@zxcvbn-ts/core";
import * as zxcvbnCommonPackage from "@zxcvbn-ts/language-common";
import * as zxcvbnDePackage from "@zxcvbn-ts/language-de";
import BaseProgressBar from "../components/BaseProgressBar.vue";

export default {
  name: "PasswortTestBar",

  components: {
    BaseProgressBar,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    extok: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["status", "changed"],

  data() {
    return {
      serverok: false,
    };
  },

  computed: {
    descriptions() {
      return [
        {
          color: "bg-red-600",
          label: "Das Passwort darf nicht mit Leerzeichen beginnen oder enden.",
          text: "[&+p]:text-red-600",
        },
        {
          color: "bg-red-600",
          label:
            "Das Passwort muss komplex sein, mehr als 6 Zeichen lang sein, Groß/Kleinschreibung, Ziffen und Sonderzeichen enthalten.",
          text: "[&+p]:text-red-600",
        },
        {
          color: "bg-red-600",
          label:
            "Dies Passwort entspricht Ihrer E-Mail, Ihrem Benutzernamen oder einem alten Passwort.",
          text: "[&+p]:text-red-600",
        },
        {
          color: "bg-red-600",
          label: "Leider ist dieses Passwort nicht sicher.",
          text: "[&+p]:text-red-600",
        },
        {
          color: "bg-red-400",
          label: "Leider ist dieses Passwort nicht sicher genug.",
          text: "[&+p]:text-red-400",
        },
        {
          color: "bg-orange-600",
          label: "Ihr Passwort ist noch nicht ganz sicher.",
          text: "[&+p]:text-orange-600",
        },
        {
          color: "bg-green-400",
          label: "Ihr Passwort kann verwendet werden, aber es sollte komplexer sein.",
          text: "[&+p]:text-yellow-600",
        },
        {
          color: "bg-green-600",
          label: "Sie haben ein sicheres Passwort eingegeben.",
          text: "[&+p]:text-green-600",
        },
      ];
    },

    score() {
      const pass = this.value;
      const eOK = this.extok;
      const hasValue = pass && pass.length > 0;
      const eLeerzeichen = pass.trim() !== pass;

      const hasDigit = /\d/;
      const hasLetter = /[a-zA-Z]/;
      const hasSpecialChar = /[^a-zA-Z0-9]/;

      if (!hasValue) {
        return 0;
      }

      if (eLeerzeichen) {
        return 1;
      }

      if (
        !(
          hasDigit.test(pass) &&
          hasLetter.test(pass) &&
          hasSpecialChar.test(pass)
        )
      ) {
        return 2;
      }

      // Serverprüfung kann hier eingebunden werden (optional)
      return !eOK ? 2 : zxcvbn(pass).score + 4;
    },

    description() {
      if (this.value && this.value.length > 0) {
        return this.descriptions[this.score - 1];
      } else {
        return {
          color: "bg-transparent",
          label: "Wir prüfen Ihr eingegebenes Passwort auf Sicherheit.",
          text: "",
        };
      }
    },

    isPasswordStrong() {
      return this.score >= 6;
    },
  },

  watch: {
    isPasswordStrong(newVal) {
      this.$emit("status", newVal);
    },

    value(newVal) {
      this.$emit("changed", this.score);
    },
  },

  created() {
    // Konfiguration des zxcvbn-Optionssystems
    zxcvbnOptions.setOptions({
      translations: zxcvbnDePackage.translations,
      graphs: zxcvbnCommonPackage.adjacencyGraphs,
      dictionary: {
        ...zxcvbnCommonPackage.dictionary,
        ...zxcvbnDePackage.dictionary,
      },
    });

    // Dummy-Call, um zxcvbn zu initialisieren
    zxcvbn("somePassword");
  },
};
</script>
